// src/components/TutorBubble.jsx
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import mascotImg from "../assets/tutor.png";
import "./TutorBubble.css";

const HIDE_AFTER = 12; // px scrolled down before it hides
const SHOW_AFTER = 12; // px scrolled up before it comes back
const TOP_ZONE = 40;   // always visible this close to the top of the page

const TutorBubble = () => {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(true);
  const [bottom, setBottom] = useState(84);
  const visibleRef = useRef(true);

  const setShown = (next) => {
    if (visibleRef.current === next) return;
    visibleRef.current = next;
    setVisible(next);
  };

  // Sit just above the bottom nav, whatever its height is on this phone
  useEffect(() => {
    let nav = null;
    let observer = null;
    let retryTimer = null;
    let tries = 0;

    const update = () => {
      if (nav) setBottom(Math.round(nav.getBoundingClientRect().height) + 12);
    };

    const attach = () => {
      nav = document.querySelector(".bottom-nav");
      if (!nav) {
        if (tries++ < 5) retryTimer = setTimeout(attach, 300);
        return;
      }
      update();
      if (typeof ResizeObserver !== "undefined") {
        observer = new ResizeObserver(update);
        observer.observe(nav);
      }
    };

    attach();
    window.addEventListener("resize", update);
    return () => {
      clearTimeout(retryTimer);
      window.removeEventListener("resize", update);
      if (observer) observer.disconnect();
    };
  }, []);

  // Hide on scroll down, show on scroll up.
  // Listening in the capture phase on window catches the page scroll AND the
  // scroll of any inner box, so it works whichever one your home screen uses.
  useEffect(() => {
    const lastY = new WeakMap();
    let acc = 0;

    const onScroll = (e) => {
      const t = e.target;
      const isDoc =
        t === document || t === document.documentElement || t === document.body || t === window;
      const y = Math.max(
        0,
        isDoc ? window.scrollY || document.documentElement.scrollTop || 0 : t.scrollTop
      );
      const key = isDoc ? document : t;
      const prev = lastY.get(key);
      lastY.set(key, y);
      if (prev === undefined) return;

      const delta = y - prev;
      if (delta === 0) return; // sideways scrolling (like tag rows) is ignored

      if (y <= TOP_ZONE) {
        acc = 0;
        setShown(true);
        return;
      }
      if (delta > 0 !== acc > 0) acc = 0; // direction changed, start counting again
      acc += delta;
      if (acc > HIDE_AFTER) setShown(false);
      else if (acc < -SHOW_AFTER) setShown(true);
    };

    window.addEventListener("scroll", onScroll, { capture: true, passive: true });
    return () => window.removeEventListener("scroll", onScroll, { capture: true });
  }, []);

  return (
    <button
      type="button"
      className={visible ? "tutor-bubble" : "tutor-bubble is-hidden"}
      style={{ "--tb-bottom": `${bottom}px` }}
      onClick={() => navigate("/tutor")}
      aria-label="Open your octopus tutor"
      aria-hidden={!visible}
      tabIndex={visible ? 0 : -1}
    >
      <img src={mascotImg} alt="" />
    </button>
  );
};

export default TutorBubble;